// @Vendors
import React from 'react';
import PropTypes from 'prop-types';

const StaticIcon = ({ src, srcSet, alt, className }) => (
  <img
  className={className}
  src={require(`../static/${src}`)}
  srcSet={srcSet ? require(`../static/${srcSet}`) : ''} alt={alt}
  />
);

StaticIcon.defaultProps = {
  alt: '',
  className: '',
  srcSet: null,
};

StaticIcon.propTypes = {
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string
};

export default StaticIcon;



// WEBPACK FOOTER //
// ./src/components/StaticImg.js